module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col space-y-4"
  }, [_c('div', {
    staticClass: "w-full select-none flex justify-between px-7 py-6 items-center border border-solid border-gray-200 cursor-pointer hover:bg-gray-100 rounded-md",
    on: {
      "click": function($event) {
        return _vm.handleOpenConfiguration('authenticator-app')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 w-8/12"
  }, [_c('h5', {
    staticClass: "font-poppins text-blueGray-800 font-semibold"
  }, [_vm._v("Two Factor Authenticator App")]), _vm._v(" "), (_vm.getProfile.two_factor_authentication_method === 'authenticator-app') ? _c('div', {
    staticClass: "rounded-full text-xs bg-green px-2 py-1 text-white"
  }, [_c('span', [_vm._v("Enable")])]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "font-light w-8/12 text-blueGray-600"
  }, [_vm._v("\n          Use an Authenticator App as your two factor authentication (2FA). \n          When you sign in you'll be asked to use the security code provided by your Authenticator App.\n        ")])])])]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-12 h-12 flex items-center rounded-full justify-center bg-gray-200"
  }, [_c('i', {
    staticClass: "fa-solid text-base text-blueGray-800 fa-mobile"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full bg-gray-100 select-none cursor-not-allowed flex justify-between px-7 py-6 items-center border border-solid border-gray-200 hover:bg-gray-100 rounded-md"
  }, [_c('div', {
    staticClass: "flex items-center space-x-5"
  }, [_c('div', [_c('div', {
    staticClass: "w-12 h-12 flex items-center rounded-full justify-center bg-gray-200"
  }, [_c('i', {
    staticClass: "fa-solid fa-envelope-open text-base text-blueGray-800"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col space-y-1.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-3 w-8/12"
  }, [_c('h5', {
    staticClass: "font-poppins text-blueGray-800 font-semibold"
  }, [_vm._v("Email for Two Factor Authentication")]), _vm._v(" "), _c('div', {
    staticClass: "rounded-full text-xs bg-blueGray-800 px-2 py-1 text-blueGray-50"
  }, [_c('span', [_vm._v("Coming Soon")])])]), _vm._v(" "), _c('h5', {
    staticClass: "font-poppins w-8/12 text-blueGray-800 font-semibold"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-light w-8/12 text-blueGray-600"
  }, [_vm._v("\n          Use the security code send to your email as your two factor authentication (2FA). The security code will be sent to the address associated with this account.\n        ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-233b1591!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/SecurityTab.vue
// module id = 1604
// module chunks = 61